import {
  createInvoiceDownloadJob as createInvoiceDownloadJobService,
  getInvoiceDownloadJobs,
  regenerateInvoiceSheet as regenerateInvoiceSheetService,
} from "../../services/InvoiceDownloadJobsService";
import { formatSuccess, formatError } from '../../services/commonServices';

export const CREATE_INVOICE_DOWNLOAD_JOB_INITIATED = "CREATE_INVOICE_DOWNLOAD_JOB_INITIATED";
export const CREATE_INVOICE_DOWNLOAD_JOB_LOADED = "CREATE_INVOICE_DOWNLOAD_JOB_LOADED";
export const CREATE_INVOICE_DOWNLOAD_JOB_FAILED = "CREATE_INVOICE_DOWNLOAD_JOB_FAILED";

export const LOAD_INVOICE_DOWNLOAD_JOBS_INITIATED = "LOAD_INVOICE_DOWNLOAD_JOBS_INITIATED";
export const LOAD_INVOICE_DOWNLOAD_JOBS_LOADED = "LOAD_INVOICE_DOWNLOAD_JOBS_LOADED";
export const LOAD_INVOICE_DOWNLOAD_JOBS_FAILED = "LOAD_INVOICE_DOWNLOAD_JOBS_FAILED";

export const REGENERATE_INVOICE_SHEET_INITIATED = "REGENERATE_INVOICE_SHEET_INITIATED";
export const REGENERATE_INVOICE_SHEET_LOADED = "REGENERATE_INVOICE_SHEET_LOADED";
export const REGENERATE_INVOICE_SHEET_FAILED = "REGENERATE_INVOICE_SHEET_FAILED";

export const createInvoiceDownloadJob = (data, onSuccess) => {
  return async (dispatch) => {
    dispatch({ type: CREATE_INVOICE_DOWNLOAD_JOB_INITIATED });
    try {
      const response = await createInvoiceDownloadJobService(data);
      dispatch({ type: CREATE_INVOICE_DOWNLOAD_JOB_LOADED });
      formatSuccess('Invoice Download Job', response.data);
      if (onSuccess) onSuccess(response.data.data);
    } catch (error) {
      if (error && error.response && error.response.data) {
        dispatch({ type: CREATE_INVOICE_DOWNLOAD_JOB_FAILED, payload: formatError(error.response.data) });
      } else {
        dispatch({ type: CREATE_INVOICE_DOWNLOAD_JOB_FAILED, payload: formatError({ message: error.message }) });
      }
    }
  };
};

export const loadInvoiceDownloadJobs = (params = {}) => {
  return async (dispatch) => {
    dispatch({ type: LOAD_INVOICE_DOWNLOAD_JOBS_INITIATED });
    try {
      const response = await getInvoiceDownloadJobs(params);
      dispatch({
        type: LOAD_INVOICE_DOWNLOAD_JOBS_LOADED,
        payload: {
          data: response.data.data?.data || [],
          pagination: response.data.data?.pagination || { total: 0, totalPages: 1, page: 1 },
        },
      });
    } catch (error) {
      dispatch({ type: LOAD_INVOICE_DOWNLOAD_JOBS_FAILED, payload: error.message });
    }
  };
};

export const regenerateInvoiceSheet = (id, onSuccess) => {
  return async (dispatch) => {
    dispatch({ type: REGENERATE_INVOICE_SHEET_INITIATED, payload: id });
    try {
      const response = await regenerateInvoiceSheetService(id);
      dispatch({
        type: REGENERATE_INVOICE_SHEET_LOADED,
        payload: { id, invoiceSheetUrl: response.data.data?.invoiceSheetUrl },
      });
      if (onSuccess) onSuccess(response.data.data);
    } catch (error) {
      dispatch({ type: REGENERATE_INVOICE_SHEET_FAILED, payload: id });
    }
  };
};
